import { TriangleDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { hinhThucMienGiamGroupApi } from "../../api/hinhThucMienGiamGroupApi";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucmiengiam_group } from "../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import { RootState } from "../../state/reducers";
type SelectBoxNhomKhoanNopProps = {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (id: number, data?: sf_hinhthucmiengiam_group) => void;
    className?: string;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
    isShowClearBtn?: boolean,
    maxWidth?: any;
    size?: "small" | "medium" | "large";
}
const SelectBoxNhomMienGiam = (props: SelectBoxNhomKhoanNopProps) => {
    const { dm_coso_id } = useSelector((x: RootState) => x.common)
    const [sf_hinhthucmiengiam_group, set_sf_hinhthucmiengiam_group] = useState<sf_hinhthucmiengiam_group[]>([])
    const { translate } = useCommonContext();
    const dispatch = useDispatch();
    useEffect(() => {
        handleReload()
    }, [])
    const handleReload = async () => {
        const res = await hinhThucMienGiamGroupApi.selectAll();
        if (res.is_success) {
            set_sf_hinhthucmiengiam_group(res.data.filter((x: any) => x.dm_coso_id == dm_coso_id));
        }
    }
    const [filter, setFilter] = useState('')
    const [open, setOpen] = useState(false)
    const dataSource = useMemo(() => {
        return sf_hinhthucmiengiam_group.map(x => {
            const item: any = {
                id: x.id,
                text: x.ma_nhom_mien_giam + ' - ' + x.ten_nhom_mien_giam,
            }
            return item;
        })
    }, [sf_hinhthucmiengiam_group, filter])

    const removeVietnameseTones = (str: string) => {
        return str
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/đ/g, "d")
            .replace(/Đ/g, "D");
    };
    const filterdData = useMemo(() => {
        const normalizedFilter = removeVietnameseTones(filter.toLowerCase());
        return dataSource.filter(item =>
            removeVietnameseTones(item.text.toLowerCase()).includes(normalizedFilter)
        );
    }, [dataSource, filter]);

    const _selectedData = useMemo(() => {
        return dataSource.find(item => item.id === props.value)
    }, [props.value, dataSource])
    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'left',
                        fontSize: props.size === "small" ? "12px" : "14px"
                    }}
                    size={props.size}
                    trailingAction={TriangleDownIcon}
                    aria-labelledby={ariaLabelledBy}
                    {...anchorProps}
                >
                    <p style={{ maxWidth: props.maxWidth, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {children || translate('Chọn nhóm miễn giảm')}
                    </p>
                </Button>
            )}
            title={<>
                <Box sx={{ display: "flex", alignItems: "left" }}>
                    <Box sx={{ flex: 1 }}>
                        Chọn nhóm miễn giảm
                    </Box>
                    {props.isShowClearBtn && (props.value ?? 0) > 0 &&
                        <Button
                            trailingVisual={XCircleFillIcon}
                            variant='invisible'
                            sx={{
                                color: "danger.emphasis"
                            }}
                            onClick={() => {
                                props.onValueChanged(0)
                            }}
                        >
                            Bỏ chọn
                        </Button>
                    }
                </Box>
            </>}
            placeholderText="Search"
            open={open}
            onOpenChange={setOpen}
            items={filterdData}
            selected={_selectedData}
            onSelectedChange={(data: any) => {
                props.onValueChanged(data.id, sf_hinhthucmiengiam_group.find(x => x.id === data.id))
            }}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'large', height: 'medium' }}
        />

    );
}
export default SelectBoxNhomMienGiam

